import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { Bills } from "src/model/class/general classes/bill";
import { ExpenseNote } from "src/model/class/general classes/expense-note";
import { CriterionExpensesNoteType } from "src/model/enum/enumExpensesNote";
import { AlertService } from "src/service/alert.service";
import { DpBillsService } from "src/service/bills.service";
import { EventService } from "src/service/event.service";
import { MomentFormats } from "src/model/class/general classes/moment-formats";

@Component({
    selector: "app-popup-details-expenses-note",
    templateUrl: "./popup-details-expenses-note.component.html",
    styleUrls: ["./popup-details-expenses-note.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupDetailsExpensesNoteComponent
  implements OnInit, OnDestroy, iEvent {
  public _eventSubscriptions: Array<Subscription> = null;
  public listBills: Array<Bills> = [];
  public isBillsLoaded: boolean = false;
  public isLoading: boolean = true;
  public showErrorContent: boolean = false;
  public billDateOutputFormat =
    MomentFormats.MOMENT_DATETIME_FORMAT_DATE_YEAR;
  @Input() modalRef: ModalController;
  public criterionExpensesNoteType = Object.keys(CriterionExpensesNoteType)
    .filter((key) => !isNaN(Number(CriterionExpensesNoteType[key])))
    .map((key) => ({
      value: CriterionExpensesNoteType[key],
      label: this.getLabelCriterio(CriterionExpensesNoteType[key]),
    }));
  public selectedBills: number[] = [];
  public showButtonContinue: boolean = false;
  public selectBills: boolean = true;
  public insertData: boolean = false;
  public lblCriterionManagement: string = "";
  public lblCriterionInvoluntary: string = "";

  private _translateSubscription: Subscription = null;

  @Input() expenseNote: ExpenseNote;

  constructor (
    private _modalController: ModalController,
    private _eventService: EventService,
    private _dpBillsService: DpBillsService,
    private _translateService: TranslateService,
    private _alertService: AlertService
  ) { }

  async ngOnInit() {
    this.subscribeEvents();
    this.loadTranslation();

    const elementManagement = this.criterionExpensesNoteType.find(
      (item) => item.value === this.expenseNote.criterionManagementExpenses
    );

    this.lblCriterionManagement = elementManagement
      ? elementManagement.label
      : null;

    const elementInvoluntary = this.criterionExpensesNoteType.find(
      (item) => item.value === this.expenseNote.criterionInvoluntaryExpenses
    );

    this.lblCriterionInvoluntary = elementInvoluntary
      ? elementInvoluntary.label
      : null;
  }
  async ngOnChange() { }

  /**
   * Load trnaslation from translation service
   */
  public loadTranslation(): void {
    this._translateSubscription = this._translateService
      .get([
        "dictionary.attention",
        "dictionary.fillAllFieldsToContinue",
        "dictionary.confirmAccounting",
        "dictionary.percVoluntaryBetween",
      ])
      .subscribe((translation) => { });
  }

  ngOnDestroy(): void {
    this.unsubscribeEvents();
  }

  /**
   * Get the label of the criterion
   * @param criterion
   * @returns
   */
  private getLabelCriterio(criterion: CriterionExpensesNoteType): string {
    if (criterion == CriterionExpensesNoteType.CONSUMPTION) {
      return "consumption";
    }
    if (criterion == CriterionExpensesNoteType.THOUSANDTHS) {
      return "thousandthsUNI";
    }
    if (criterion == CriterionExpensesNoteType.THOUSANDTHS_HEATING) {
      return "thousandthsHeating";
    }
  }

  /**
   * Close modal and return index selected
   * @param valSelected
   */
  public closeModal() {
    this.modalRef.dismiss();
  }

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnMakeForceLogout.subscribe(() => {
        this._modalController.dismiss();
      })
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
    this._translateSubscription?.unsubscribe();
  }
  //#endregion
}
